'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CallEventType = exports.CallState = exports.createServiceForTest = exports.fixNestedModelValidation = exports.Void = exports.hash2query = exports.Domain = undefined;

var _Domain = require('./Domain');

Object.defineProperty(exports, 'Domain', {
  enumerable: true,
  get: function get() {
    return _Domain.Domain;
  }
});

var _urlUtils = require('./urlUtils');

Object.defineProperty(exports, 'hash2query', {
  enumerable: true,
  get: function get() {
    return _urlUtils.hash2query;
  }
});

var _Void = require('./rpc/Void');

Object.defineProperty(exports, 'Void', {
  enumerable: true,
  get: function get() {
    return _Void.Void;
  }
});

var _nestedModelValidationFix = require('./nestedModelValidationFix');

Object.defineProperty(exports, 'fixNestedModelValidation', {
  enumerable: true,
  get: function get() {
    return _nestedModelValidationFix.fixNestedModelValidation;
  }
});

var _createServiceForTest = require('./rpc/createServiceForTest');

Object.defineProperty(exports, 'createServiceForTest', {
  enumerable: true,
  get: function get() {
    return _createServiceForTest.createServiceForTest;
  }
});

var _CallState = require('./rpc/CallState');

Object.defineProperty(exports, 'CallState', {
  enumerable: true,
  get: function get() {
    return _CallState.CallState;
  }
});

var _CallEventType = require('./rpc/CallEventType');

Object.defineProperty(exports, 'CallEventType', {
  enumerable: true,
  get: function get() {
    return _CallEventType.CallEventType;
  }
});

require('./extendModel');

if (Object.extend && Object.extend.error) {
  Object.assign(Object.extend.error, {
    overrideMethodWithValue: function overrideMethodWithValue() {},
    unknownAttribute: function unknownAttribute() {}
  });
}


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/nested-hateoas/dist/main.js
// module id = 141
// module chunks = 118